import { Component } from "@angular/core";

@Component({
  selector: "icon-warning-tramite",
  templateUrl: "./warning.svg",
  standalone: true,
})
export class WarningTramiteIconComponent {}
